import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins";
import vuetify from "./plugins/vuetify";
//import socket from "./plugins/socket";
import { sync } from "vuex-router-sync";

/** ************New******************* */
import UUID from "vue-uuid";

import Notifications from "vue-notification";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import JsonCSV from "vue-json-csv";
import { i18n } from "./plugins/i18n";
/// user the json editor
import VJsoneditor from "v-jsoneditor";

import VueApexCharts from "vue-apexcharts";
import VueFusionChartsComponent from "vue-fusioncharts/component";

// import FusionCharts modules and resolve dependency
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";

(async () => {
  sync(store, router);

  await store
    .dispatch("FETCH_ADMIN_I18N")
    .then(() => {
      console.log("-> i18n is set");
    })
    .catch((err) => console.log(err));
  await store
    .dispatch("FETCH_ADMIN_USERS")
    .then((r) => {
      console.log("-> admin store details is set");
    })
    .catch((err) => console.log(err));
  await store
    .dispatch("FETCH_STORE_CONFIG")
    .then(() => {
      console.log("-> config is set");
    })
    .catch((err) => console.log(err));
  Vue.use(VJsoneditor);
  Vue.component("downloadCsv", JsonCSV);
  Vue.use(UUID);
  Vue.config.productionTip = false;
  Vue.use(Notifications);
  Vue.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true,
  });
  //charts
  Vue.use(VueApexCharts);
  Vue.component("apexchart", VueApexCharts);

  const vueFusionCharts = VueFusionChartsComponent(FusionCharts, Charts);

  Vue.component("fusioncharts", vueFusionCharts);
  FusionCharts.options = {
    creditLabel: false,
  };
  /** **************************** */

  new Vue({
    router,
    store,
    i18n: i18n.get(),
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
})();
